//Author June Leow
//Date Mar 25th, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, generateTooltip, showMessage} from '../../../../util/util';
import {Card, CardHeader, CardBody, Input} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import MySelect from '../../../util/my-select';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {

};



const interiorDeficiencyNameEnum = [
  {value:'FLOORING', label:'Flooring'},
  {value:'PLUMBING_FIXTURES', label:'Plumbing Fixtures'},
  {value:'ELECTRICAL_FIXTURES', label:'Electrical Fixtures'},
  {value:'CABINET_COUNTERTOPS', label:'Cabinet Countertops'},
  {value:'APPLIANCES', label:'Appliances'},
  {value:'WALLS', label:'Walls'},
  {value:'CEILING', label:'Ceiling'},
  {value:'SHOWER_TUB_SURROUND', label:'Shower Tub Surround'},
  {value:'OTHER', label:'Other'},
  {value:'NONE_OBSERVED', label:'None Observed'},
]

const interiorDeficiencyTypeEnum = [
  {value:'EXCESSIVE_WEAR', label:'Excessive Wear'},
  {value:'DAMAGE', label:'Damage'},
  {value:'EVIDENCE_OF_MOLD', label:'Evidence of Mold'},
  {value:'EVIDENCE_OF_INFESTATION', label:'Evidence of Infestation'},
  {value:'MISSING', label:'Missing'},
  {value:'POOR_FUNCTIONAL_UTILITY', label:'Poor Functional Utility'},
  {value:'OTHER', label:'Other'},
]

const interiorDeficiencyDetailFlooringEnum = [
  {value:'BUCKLED', label:'Buckled'},
  {value:'HOLES', label:'Holes'},
  {value:'SAGGING', label:'Sagging'},
  {value:'SPONGY', label:'Spongy'},
  {value:'INFESTATION', label:'Infestation'},
  {value:'DRY_ROT', label:'Dry Rot'},
  {value:'DISCOLORATION', label:'Discoloration'},
  {value:'CRACKS', label:'Cracks'},
  {value:'UNFINISHED_SECTION', label:'Unfinished Section'},
  {value:'DAMPNESS', label:'Dampness'},
  {value:'OTHER', label:'Other'},
]

const interiorDeficiencyDetailCeilingEnum = [
  {value:'DISCOLORATION', label:'Discoloration'},
  {value:'MISSING', label:'Missing'},
  {value:'CRUMBLING', label:'Crumbling'},
  {value:'WATER_DAMAGE', label:'Water Damage'},
  {value:'OTHER', label:'Other'},
]

const interiorDeficiencyDetailWallsEnum = [
  {value:'DISCOLORATION', label:'Discoloration'},
  {value:'MISSING', label:'Missing'},
  {value:'CRUMBLING', label:'Crumbling'},
  {value:'WATER_DAMAGE', label:'Water Damage'},
  {value:'OTHER', label:'Other'},
]

const interiorUpdatedComponentEnum = [
  {value:'FLOORING', label:'Flooring'},
  {value:'PLUMBING_FIXTURES', label:'Plumbing Fixtures'},
  {value:'ELECTRICAL_FIXTURES', label:'Electrical Fixtures'},
  {value:'CABINET_COUNTERTOPS', label:'Cabinet Countertops'},
  {value:'APPLIANCES', label:'Appliances'},
  {value:'WALLS', label:'Walls'},
  {value:'CEILING', label:'Ceiling'},
  {value:'OTHER', label:'Other'},
  {value:'NONE_OBSERVED', label:'None Observed'},
]

const interiorUpdateTypeEnum = [
  {value:'FULLY_UPDATED', label:'Fully Updated'},
  {value:'PARTIALLY_UPDATED', label:'Partially Updated'},
]

const interiorUpdateTimeframeEnum = [
  {value:'LESS_THAN_1_YEAR', label:'Less than 1 Year'},
  {value:'1_TO_5_YEARS', label:'1 to 5 Years'},
  {value:'5_TO_10_YEARS', label:'5 to 10 Years'},
  {value:'10_OR_MORE_YEARS', label:'10 or more Years'}
]

const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update
const reducer = getReducer();


const InteriorDeficienciesUpdates  = (props)=>{
  const controller = new AbortController();

  const [, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);
  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const getCompressRatio = (size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  const updateFileDescription = (index, index2, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let interiorDeficiencies = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies.slice():null;
    let target = interiorDeficiencies[index][field]?interiorDeficiencies[index][field]:[];
    if(target &&  target[index2]){
      target[index2].description = description;
    }

    newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies = interiorDeficiencies;
    props.update(newUPD);
  }

  const updateFileDescription2 = (index, index2, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let interiorUpdates = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates.slice():null;
    let target = interiorUpdates[index][field]?interiorUpdates[index][field]:[];
                
    if(target &&  target[index2]){
      target[index2].description = description;
    }

    newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates = interiorUpdates;
    props.update(newUPD);
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop = (acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{
    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let interiorDeficiencies = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies.slice():null;
   
                let target = interiorDeficiencies[index][field]?interiorDeficiencies[index][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:interiorDeficiencies[index].ID, description:description});
                interiorDeficiencies[index][field] = target;
                newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies = interiorDeficiencies;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const removeFile = (field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let interiorDeficiencies = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies.slice():null;
   
    let target = interiorDeficiencies[index][field].slice();

    let targetToDelete = target[index2];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index2, 1);
        interiorDeficiencies[index][field] = target;
        newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies = interiorDeficiencies;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index2, 1);
      interiorDeficiencies[index][field] = target;
      newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies = interiorDeficiencies;
      props.update(newUPD);
    }
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop2 = (acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{
    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let interiorUpdates = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates.slice():null;
   
                let target = interiorUpdates[index][field]?interiorUpdates[index][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:interiorUpdates[index].ID, description:description});
                interiorUpdates[index][field] = target;
                newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates = interiorUpdates;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const removeFile2 = (field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let interiorUpdates = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates.slice():null;
   
    let target = interiorUpdates[index][field].slice();

    let targetToDelete = target[index2];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index2, 1);
        interiorUpdates[index][field] = target;
        newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates = interiorUpdates;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index2, 1);
      interiorUpdates[index][field] = target;
      newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates = interiorUpdates;
      props.update(newUPD);
    }
  }

  const getInteriorDeficiencyNameLabel = (value)=>{
    for(let i=0;i<interiorDeficiencyNameEnum.length;i++){
      if(interiorDeficiencyNameEnum[i].value===value)
        return interiorDeficiencyNameEnum[i].label;
    }
    return value;
  }

  const getInteriorDeficiencyDetailFlooringLabel = (value)=>{
    for(let i=0;i<interiorDeficiencyDetailFlooringEnum.length;i++){
      if(interiorDeficiencyDetailFlooringEnum[i].value===value)
        return interiorDeficiencyDetailFlooringEnum[i].label;
    }
    return value;
  }

  const getInteriorDeficiencyDetailCeilingLabel = (value)=>{
    for(let i=0;i<interiorDeficiencyDetailCeilingEnum.length;i++){
      if(interiorDeficiencyDetailCeilingEnum[i].value===value)
        return interiorDeficiencyDetailCeilingEnum[i].label;
    }
    return value;
  }

  const getInteriorDeficiencyDetailWallsLabel = (value)=>{
    for(let i=0;i<interiorDeficiencyDetailWallsEnum.length;i++){
      if(interiorDeficiencyDetailWallsEnum[i].value===value)
        return interiorDeficiencyDetailWallsEnum[i].label;
    }
    return value;
  }

  const getInteriorUpdatedComponentLabel = (value)=>{
    for(let i=0;i<interiorUpdatedComponentEnum.length;i++){
      if(interiorUpdatedComponentEnum[i].value===value)
        return interiorUpdatedComponentEnum[i].label;
    }
    return value;
  }

  const updateDeficiency = (value)=>{
    let newUPD = Object.assign({}, props.upd);
    let interiorDeficiencies = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies.slice():null;
    if(value==='NONE_OBSERVED'){
      interiorDeficiencies = [{interiorDeficiencyName:value}];
    }
    else{
      for(let i=0;i<interiorDeficiencies.length;i++){
        if(interiorDeficiencies[i].interiorDeficiencyName==='NONE_OBSERVED'){
          interiorDeficiencies = [];
          break;
        }
      }
      interiorDeficiencies.push({interiorDeficiencyName:value, imageDeficiency:[]});
    }

    newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies = interiorDeficiencies;
    props.update(newUPD);
  }

  const updateUpdatedComponent = (value)=>{
    let newUPD = Object.assign({}, props.upd);
    let interiorUpdates = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates.slice():null;
 
    if(value==='NONE_OBSERVED'){
      interiorUpdates = [{interiorUpdatedComponent:value}];
    }
    else{
      for(let i=0;i<interiorUpdates.length;i++){
        if(interiorUpdates[i].interiorUpdatedComponent==='NONE_OBSERVED'){
          interiorUpdates = [];
          break;
        }
      }
  
      interiorUpdates.push({interiorUpdatedComponent:value, imageUpdate:[]});
    }

    newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates = interiorUpdates;
    props.update(newUPD);
  }

  const updateUpdatedComponentDetail = (index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let interiorUpdates = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates.slice():null;
    interiorUpdates[index][field] = value;
    newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates = interiorUpdates;
    props.update(newUPD);
  }

  const updateDeficienciesDetailArray = (index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let interiorDeficiencies = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies.slice():null;
    let array = interiorDeficiencies[index][field]?interiorDeficiencies[index][field].slice():[];
    if(array.indexOf(value)===-1)
      array.push(value);
      interiorDeficiencies[index][field] = array;
    newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies = interiorDeficiencies;
    props.update(newUPD);
  }

  const removeDeficienciesDetailArray = (index, field, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let interiorDeficiencies = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies.slice():null;
    let array = interiorDeficiencies[index][field].slice();
    array.splice(index2, 1);
    interiorDeficiencies[index][field] = array;
    newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies = interiorDeficiencies;
    props.update(newUPD);
  }

  const updateDeficienciesDetail = (index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let interiorDeficiencies = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies.slice():null;
    interiorDeficiencies[index][field] = value;
    newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies = interiorDeficiencies;
    props.update(newUPD);
  }

  const removeDeficiency = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let interiorDeficiencies = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies.slice():null;
    interiorDeficiencies.splice(index, 1);
    newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies = interiorDeficiencies;
    props.update(newUPD);
  }

  const removeUpdatedComponent = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let interiorUpdates = newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates?newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates.slice():null;
    interiorUpdates.splice(index, 1);
    newUPD.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates = interiorUpdates;
    props.update(newUPD);
  }

  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }

  //render
  return <div>
    <label>{!props.disabled?<font color="red">*</font>:null}What are the item(s) / component(s) of this room with damage or wear that require repairs? {generateTooltip('interiorDeficiencyName','Indicate if any portion or element of a room has deferred maintenance and requiring repairs.  Also indicate if any item is missing altogether. ')}</label>
    <MySelect
      type="select"
      required={!props.disabled}
      disabled={props.disabled}
      style={props.disabled?disabledStyling:{}}
      value={props.upd.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies && props.upd.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies.length>0?" ":""}
      onChange={(v)=>updateDeficiency(v)}
      options={interiorDeficiencyNameEnum}
    />
    {
      props.upd.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorDeficiencies.map(
        (interiorDeficiency, index)=>{
          if(interiorDeficiency.interiorDeficiencyName==='NONE_OBSERVED'){
            return <div key={index} style={{marginTop:'15px'}}>
              <b>None Observed</b>
            </div>
          }

          return <div key={index}>
            <Card>
              <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeDeficiency(index)}/> {getInteriorDeficiencyNameLabel(interiorDeficiency.interiorDeficiencyName)} Interior Deficiency</CardHeader>
              <CardBody>
                <label>{!props.disabled?<font color="red">*</font>:null}What type of damage or wear did you observe? {generateTooltip('interiorDeficiencyType'+index,'User to identify the type of deficiency type for the item / component selected.')}</label>
                <MySelect
                  type="select"
                  required={!props.disabled}
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  value={interiorDeficiency.interiorDeficiencyType}
                  onChange={(v)=>updateDeficienciesDetail(index, 'interiorDeficiencyType', v)}
                  options={interiorDeficiencyTypeEnum}
                />
                <br/>
                {interiorDeficiency.interiorDeficiencyName==='FLOORING'?<div>
                  <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the component selected. {generateTooltip('interiorDeficiencyDetailFlooring'+index,'User to select the detail for the item / component showing damage or wear and tear.')}</label>
                  <MySelect
                    type="select"
                    required={!props.disabled}
                    disabled={props.disabled}
                    style={props.disabled?disabledStyling:{}}
                    value={interiorDeficiency.interiorDeficiencyDetailFlooring && interiorDeficiency.interiorDeficiencyDetailFlooring.length>0?" ":""}
                    onChange={(v)=>updateDeficienciesDetailArray(index, 'interiorDeficiencyDetailFlooring', v)}
                    options={interiorDeficiencyDetailFlooringEnum}
                  />
                  {
                    interiorDeficiency.interiorDeficiencyDetailFlooring?interiorDeficiency.interiorDeficiencyDetailFlooring.map(
                      (interiorDeficiencyDetailFlooring, index2)=>{
                        return <span className="my-badge3" key={index2} style={{marginRight:'5px', padding:'10px'}}>
                        <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeDeficienciesDetailArray(index, 'interiorDeficiencyDetailFlooring', index2)}/> {getInteriorDeficiencyDetailFlooringLabel(interiorDeficiencyDetailFlooring)}
                      </span>
                      }
                    ):null
                  }
                </div>:null}
                {interiorDeficiency.interiorDeficiencyName==='CEILING'?<div>
                  <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the component selected. {generateTooltip('interiorDeficiencyDetailCeiling'+index,'User to select the detail for the item / component showing damage or wear and tear.')}</label>
                  <MySelect
                    type="select"
                    required={!props.disabled}
                    disabled={props.disabled}
                    style={props.disabled?disabledStyling:{}}
                    value={interiorDeficiency.interiorDeficiencyDetailCeiling && interiorDeficiency.interiorDeficiencyDetailCeiling.length>0?" ":""}
                    onChange={(v)=>updateDeficienciesDetailArray(index, 'interiorDeficiencyDetailCeiling', v)}
                    options={interiorDeficiencyDetailCeilingEnum}
                  />
                  {
                    interiorDeficiency.interiorDeficiencyDetailCeiling?interiorDeficiency.interiorDeficiencyDetailCeiling.map(
                      (interiorDeficiencyDetailCeiling, index2)=>{
                        return <span className="my-badge3" key={index2} style={{marginRight:'5px', padding:'10px'}}>
                        <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeDeficienciesDetailArray(index, 'interiorDeficiencyDetailCeiling', index2)}/> {getInteriorDeficiencyDetailCeilingLabel(interiorDeficiencyDetailCeiling)}
                      </span>
                      }
                    ):null
                  }
                </div>:null}
                {interiorDeficiency.interiorDeficiencyName==='WALLS'?<div>
                  <label>{!props.disabled?<font color="red">*</font>:null}What signs of damage or wear were observed for the component selected. {generateTooltip('interiorDeficiencyDetailWalls'+index,'User to select the detail for the item / component showing damage or wear and tear.')}</label>
                  <MySelect
                    type="select"
                    required={!props.disabled}
                    disabled={props.disabled}
                    style={props.disabled?disabledStyling:{}}
                    value={interiorDeficiency.interiorDeficiencyDetailWalls && interiorDeficiency.interiorDeficiencyDetailWalls.length>0?" ":""}
                    onChange={(v)=>updateDeficienciesDetailArray(index, 'interiorDeficiencyDetailWalls', v)}
                    options={interiorDeficiencyDetailWallsEnum}
                  />
                  {
                    interiorDeficiency.interiorDeficiencyDetailWalls?interiorDeficiency.interiorDeficiencyDetailWalls.map(
                      (interiorDeficiencyDetailWalls, index2)=>{
                        return <span className="my-badge3" key={index2} style={{marginRight:'5px', padding:'10px'}}>
                        <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeDeficienciesDetailArray(index, 'interiorDeficiencyDetailWalls', index2)}/> {getInteriorDeficiencyDetailWallsLabel(interiorDeficiencyDetailWalls)}
                      </span>
                      }
                    ):null
                  }
                </div>:null}
                {interiorDeficiency.interiorDeficiencyName==='SHOWER_TUB_SURROUND'?<div>
                  <label>{!props.disabled?<font color="red">*</font>:null}Are there signs of erosion for the component selected? {generateTooltip('interiorDeficiencyDetailTubShowerSurround'+index,'User to identify if there signs of erosion for the component selected?.')}</label>
                  <MySelect
                    type="select"
                    required={!props.disabled}
                    disabled={props.disabled}
                    style={props.disabled?disabledStyling:{}}
                    value={interiorDeficiency.interiorDeficiencyDetailTubShowerSurround}
                    onChange={(v)=>updateDeficienciesDetail(index, 'interiorDeficiencyDetailTubShowerSurround', v)}
                    options={[{label:"True",value:"True"},{label:"False",value:"False"}]}
                  />
                </div>:null}
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Does the deficiency impact the safety, soundness or structural integrity of the structure or unit? {generateTooltip('interiorDeficiencySeverity'+index,'User to select whether the deficient item does (TRUE) or does not (FALSE) impact the safety, structural integrity of the affected room. True = Deficiency impacts the safety, soundness or structural integrity of the affected room. False = The deficiency does NOT affect the safety,  soundness or structural integrity of the affected room.')}</label>
                <MySelect
                  type="select"
                  required={!props.disabled}
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  value={interiorDeficiency.interiorDeficiencySeverity}
                  onChange={(v)=>updateDeficienciesDetail(index, 'interiorDeficiencySeverity', v)}
                  options={[{label:"True",value:"True"},{label:"False",value:"False"}]}
                />
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Provide a concise description of each deficiency observed. {generateTooltip('interiorDeficiencyDescription'+index, 'User to provide a text description of any deficiencies observed.')}</label>
                <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={interiorDeficiency.interiorDeficiencyDescription} onChange={(e)=>updateDeficienciesDetail(index,'interiorDeficiencyDescription', e.target.value)}/>

                <br/><div className="my-divider"/>
                <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of deficiency</label>
                <br/>
                <input
                  tabIndex={-1}
                  autoComplete="off"
                  style={{ opacity: 0, height: 0, width:0 }}
                  value={interiorDeficiency.imageDeficiency&&interiorDeficiency.imageDeficiency.length>0?" ":""}
                  required={!props.disabled}
                />
                <div>
                  <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageDeficiency', interiorDeficiency.interiorDeficiencyName+'_INTERIOR_DEFICIENCY', 0)}} className="my-dropzone">
                  {
                    ({getRootProps, getInputProps}) => (
                      <div
                        {...getRootProps({
                          className: 'my-dropzone',
                        })}
                      >
                        <input {...getInputProps()} />
                        <center>Choose files to upload</center>
                      </div>
                    )
                  }
                  </Dropzone>
                  {
                    !interiorDeficiency.imageDeficiency?null:interiorDeficiency.imageDeficiency.map(
                      (photo, index3)=>{
                        return <div key={index3} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                          <div>
                            <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageDeficiency',index, index3)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                          </div>
                          <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                          <div style={{marginTop:'5px'}}/>
                          {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index3, 'imageDeficiency', e.target.value)}/>
                          <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                        </div>
                      }
                    )
                  }
                </div>
              </CardBody>
            </Card>
            <br/>
          </div>
        }
      )
    }
    <br/>
    <label>{!props.disabled?<font color="red">*</font>:null}Select any applicable interior component(s) from the list that have been updated. {generateTooltip('interiorUpdatedComponent','Indicate which item(s) / component(s) have been updated. Select all that apply')}</label>
    <MySelect
      type="select"
      required={!props.disabled}
      disabled={props.disabled}
      style={props.disabled?disabledStyling:{}}
      value={props.upd.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates && props.upd.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates.length>0?" ":""}
      onChange={(v)=>updateUpdatedComponent(v)}
      options={interiorUpdatedComponentEnum}
    />
    {
      props.upd.property.buildings[props.index].units[props.index2].levels[props.index3].rooms[props.index4].interiorUpdates.map(
        (interiorUpdate, index)=>{
          if(interiorUpdate.interiorUpdatedComponent==='NONE_OBSERVED'){
            return <div key={index} style={{marginTop:'15px'}}>
              <b>None Observed</b>
            </div>
          }

          return <div key={index}>
            <Card>
              <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeUpdatedComponent(index)}/> {getInteriorUpdatedComponentLabel(interiorUpdate.interiorUpdatedComponent)} Interior Updates</CardHeader>
              <CardBody>
                <label>{!props.disabled?<font color="red">*</font>:null}Select to what degree  the component was updated. {generateTooltip('interiorUpdateType'+index,'User to select the manner in which the item(s) / component(s) was updated.')}</label>
                <MySelect
                  type="select"
                  required={!props.disabled}
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  value={interiorUpdate.interiorUpdateType}
                  onChange={(v)=>updateUpdatedComponentDetail(index, 'interiorUpdateType', v)}
                  options={interiorUpdateTypeEnum}
                />
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}How long ago was the update to the room completed? {generateTooltip('interiorUpdateTimeframe'+index,'User to select the approximate timeframe in which the update was completed. ')}</label>
                <MySelect
                  type="select"
                  required={!props.disabled}
                  disabled={props.disabled}
                  style={props.disabled?disabledStyling:{}}
                  value={interiorUpdate.interiorUpdateTimeframe}
                  onChange={(v)=>updateUpdatedComponentDetail(index, 'interiorUpdateTimeframe', v)}
                  options={interiorUpdateTimeframeEnum}
                />
                <br/>
                <label>{!props.disabled?<font color="red">*</font>:null}Provide a concise description of every interior update identified. {generateTooltip('interiorUpdateDescription'+index, 'User to provide a free form text description of the interior update(s) identified within the room.')}</label>
                <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={interiorUpdate.interiorUpdateDescription} onChange={(e)=>updateUpdatedComponentDetail(index,'interiorUpdateDescription', e.target.value)}/>

                <br/><div className="my-divider"/>
                <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of updated component</label>
                <br/>
                <input
                  tabIndex={-1}
                  autoComplete="off"
                  style={{ opacity: 0, height: 0, width:0 }}
                  value={interiorUpdate.imageUpdate&&interiorUpdate.imageUpdate.length>0?" ":""}
                  required={!props.disabled}
                />
                <div>
                  <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop2(accepted, rejected, index, 'imageUpdate', interiorUpdate.interiorUpdatedComponent+'_INTERIOR_UPDATE', 0)}} className="my-dropzone">
                  {
                    ({getRootProps, getInputProps}) => (
                      <div
                        {...getRootProps({
                          className: 'my-dropzone',
                        })}
                      >
                        <input {...getInputProps()} />
                        <center>Choose files to upload</center>
                      </div>
                    )
                  }
                  </Dropzone>
                  {
                    !interiorUpdate.imageUpdate?null:interiorUpdate.imageUpdate.map(
                      (photo, index3)=>{
                        return <div key={index3} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                          <div>
                            <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile2('imageUpdate',index, index3)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                          </div>
                          <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                          <div style={{marginTop:'5px'}}/>
                          {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription2(index, index3, 'imageUpdate', e.target.value)}/>
                          <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                        </div>
                      }
                    )
                  }
                </div>
              </CardBody>
            </Card>
            <br/>
          </div>
        }
      )
    }
  </div>
}


export default InteriorDeficienciesUpdates;